"use client";
import React from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import commentsApi from "@/api/comments/nft/client";
import useMe from "@/shared/hooks/useMe";
import { Nft } from "@/api/nfts/types";
import { NftCommentDto } from "@/api/comments/nft/types";
import Comment from "..";
import useNftCommentLike from "../../../Likes/hooks/useNftCommentLike";
export interface Props {
  nft?: Nft;
  comment: NftCommentDto;
}

export default function NftComment({ nft, comment }: Props) {
  const queryClient = useQueryClient();

  const { me } = useMe();

  const { mutateAsync: postNftComment } = useMutation({
    mutationFn: (text: string) =>
      commentsApi.postNftComment({
        text,
        repliedToNftId: comment.repliedToNftId!,
        authorId: me?.id,
        repliedToCommentId: comment.id,
      }),
    onSuccess: () => {
      queryClient.invalidateQueries(["nft-comments", comment.repliedToNftId]);
    },
  });

  const { mutateAsync: deleteNftComment } = useMutation({
    mutationFn: commentsApi.deleteNftComment,
    onSuccess: () => {
      queryClient.invalidateQueries(["nft-comments", comment.repliedToNftId]);
    },
  });

  const { isLikedByMe, toggleLike, likeCount } = useNftCommentLike({
    commentId: comment.id,
    user: me,
  });

  return (
    <Comment
      nft={nft}
      comment={comment}
      onPost={async (text: string) => await postNftComment(text)}
      onDelete={async (id: string) => await deleteNftComment(id)}
      likeState={{
        isLikedByMe,
        toggleLike,
        likeCount,
      }}
    />
  );
}
